import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { routes, requestStatus } from '../constants';
import { GridForm, Input, Button } from '../components';
import { AuthActions } from '../actions';
import { formValidators } from '../utils';

const defaultError = {
    message: ''
}

class LoginForm extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            formError: defaultError,
            busy: false,
            login: {
                username: '',
                password: ''
            }
        }
    }

    formError(err) {
        this.setState({
            formError: err
        });
    }

    resetFormError() {
        this.setState({
            formError: defaultError
        });
    }

    getHandler(key) {
        return event => {
            let update = {};
            update[key] = event.target.value;
            this.setState({
                login: Object.assign({}, this.state.login, update)
            });
        }
    }

    validate() {
        this.resetFormError();

        if (formValidators.email()(this.state.login.username)) {
            this.formError({
                message: 'Please enter a valid email address and password.'
            });
            return false;
        }

        if (formValidators.required()(this.state.login.password)) {
            this.formError({
                message: 'Please enter a valid email address and password.'
            });
            return false;
        }

        return true;
    }

    render () {

        const submitHandler = (event) => {
            event.preventDefault();

            if (this.validate()) {
                this.setState({busy: true});
                this.props.dispatch(AuthActions.authenticate(this.state.login));
                if (this.props.onComplete) {
                    this.props.onComplete(this.state.login);
                }
            }
        }

        let errorMessage = this.state.formError.message.anchor,
            hasError = this.props.loginStatus.status === requestStatus.ERROR;

        if (this.props.loginStatus.status === requestStatus.ERROR) {
            errorMessage = 'The email address or password is incorrect.';
        }

        return (
            <form onSubmit={submitHandler}>
                <GridForm className="login-grid">
                    <div className="form-group">
                        <label className="form-control">Email</label>
                        <Input className="form-control" onInput={this.getHandler('username')} onChange={this.getHandler('username')} type="text" />
                    </div>
                    <div className="form-group">
                        <label className="form-control">Password</label>
                        <Input className="form-control" onInput={this.getHandler('password')} onChange={this.getHandler('password')} type="password" />
                    </div>
                </GridForm>

                <div className="login-footer">
                    <div className="form-error">
                        {errorMessage}
                    </div>
                    <div className="login-links">
                        <Link to={routes.FORGOT_PASSWORD}>Forgot Password?</Link>
                    </div>
                    <div className="login-actions">
                        <Button busy={this.state.busy && !hasError} className="primary" type="submit">Sign In</Button>
                    </div>
                </div>
            </form>
        )
    }
}

function select(state) {
    return {
        loginStatus: state.loginStatus,
        activeUser: state.activeUser
    }
}

export default connect(select)(LoginForm);



// WEBPACK FOOTER //
// ./web-app/components/login-form.jsx